export default __webpack_public_path__ + "static/media/factura2.fa7fa2ee.pdf";